import { Instance } from 'mobx-state-tree';
import { RouteStopMovedDtoModelBase } from './RouteStopMovedDtoModel.base';

/* The TypeScript type of an instance of RouteStopMovedDtoModel */
export interface RouteStopMovedDtoModelType extends Instance<typeof RouteStopMovedDtoModel.Type> {}

/* A graphql query fragment builders for RouteStopMovedDtoModel */
export { selectFromRouteStopMovedDto, routeStopMovedDtoModelPrimitives, RouteStopMovedDtoModelSelector } from './RouteStopMovedDtoModel.base';

/**
 * RouteStopMovedDtoModel
 *
 * Route moving stop event
 */
export const RouteStopMovedDtoModel = RouteStopMovedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
